import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["templateSelect", "subjectInput", "bodyInput", "subjectPreview", "bodyPreview"]
  static values = {
    templates: Object,
    lead: Object
  }

  connect() {
    this.update()
  }

  applyTemplate() {
    if (!this.hasTemplateSelectTarget) return

    const template = this.templatesValue?.[this.templateSelectTarget.value]
    if (!template) return

    if (this.hasSubjectInputTarget) {
      this.subjectInputTarget.value = this.interpolate(template.subject || "")
    }

    if (this.hasBodyInputTarget) {
      this.bodyInputTarget.value = this.interpolate(template.body || "")
    }

    this.update()
  }

  update() {
    if (this.hasSubjectPreviewTarget && this.hasSubjectInputTarget) {
      const placeholder = this.subjectPreviewTarget.dataset.placeholder || ""
      const value = this.subjectInputTarget.value.trim()
      this.subjectPreviewTarget.textContent = value.length ? value : placeholder
    }

    if (this.hasBodyPreviewTarget && this.hasBodyInputTarget) {
      const placeholder = this.bodyPreviewTarget.dataset.placeholder || ""
      const value = this.bodyInputTarget.value.trim()
      this.bodyPreviewTarget.textContent = value.length ? value : placeholder
    }
  }

  interpolate(content) {
    return content.replace(/%\{([a-z_]+)\}/g, (_match, key) => this.leadValue?.[key] || "")
  }
}
